export const getFigmaFileId = (link) => (link ? link.split('/')[4] : '');
